<template>
  <Modal title="作废订单" :loading="true" v-model="modalVisible" :mask-closable="false">
    <Form class="sm" ref="form" :model="form" :rules="rules">
      <FormItem prop="operaExplain">
        <Input type="textarea" placeholder="请输入理由" v-model="form.operaExplain"></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      modalVisible:false,
      rules: {
        operaExplain: [
          { required: true, message: '请输入理由', trigger: 'blur,change' },
        ],
      },
      form: {
        id: '',
        operaExplain: null
      },
      loading:false
    }
  },

  mounted() {},

  methods: {
    init(id) {
      this.$refs['form'].resetFields()
      this.form.id = id
      this.form.operaExplain = null

      if(id){
        this.modalVisible = true
      }
    },

    save() {
      //
      let params = { ...this.form }

      this.loading = true
      this.$request.orderCancel(params).then(resp => {
        this.loading = false
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('操作成功')
          this.$emit('on-update')
          this.modalVisible = false
        }
        this.loading = false
      })

    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误')
        }
      })
    },
  }
}
</script>